export default "__VITE_ASSET__Bx7yPOT7__"